export const PROFILE_FILE_KEYS = [
  'headerLogo',
  'footerLogo',
  'headerImage',
  'footerImage',
] as const;
